import script from "./Microeconomics.vue?vue&type=script&setup=true&lang=js"
export * from "./Microeconomics.vue?vue&type=script&setup=true&lang=js"

import "./Microeconomics.vue?vue&type=style&index=0&id=e1725a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1725a86"]])

export default __exports__